// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 2 ? "vendor-base" : chunkId) + "-" + {"2":"d7469052b3","416":"3a41619956"}[chunkId] + ".js";
};